import React from 'react';
import { Form } from '@dashboard/components/Formik';
import usePage from '@dashboard/hooks/usePage';

const CheckoutAbandonmentForm = () => {
  const { page, updatePage } = usePage();

  return (
    <>
      <Form
        enableReinitialize
        initialValues={{
          disableEmails: page?.checkoutAbandonment?.disableEmails,
        }}
        fields={[
          {
            name: 'disableEmails',
            type: 'checkbox',
            label: 'Disable email reminders',
          },
        ]}
        onSubmit={async values => {
          const payload = {
            checkoutAbandonment: {
              ...page.checkoutAbandonment,
              ...values,
            },
          };

          const { data, error } = await updatePage.mutateAsync(payload);

          return {
            data,
            error,
          };
        }}
      />
    </>
  );
};

export default CheckoutAbandonmentForm;
